import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const customBookingFormFieldVisibilityConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default customBookingFormFieldVisibilityConfigEntity
